module.exports = __webpack_public_path__ + "img/heart_intelligence.150618a7.png";